<template>
  <v-dialog v-model="open" width="534px">
    <v-card dense>
      <v-toolbar elevation="0" class="mt-2">
        <v-toolbar-title
          class="body-bold-medium neutral-20-dark--text d-flex flex-column"
          style="padding-left: 10px"
        >
          {{ title }}
          <span class="body-regular-smaller neutral-40-light--text">{{
            subtitle
          }}</span>
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn icon @click="handleCloseModal()">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <v-card-text class="px-7 py-0">
        <v-row no-gutters>
          <v-col cols="12">
            <span class="body-regular-small neutral-40-light--text">{{
              description
            }}</span>
          </v-col>
          <v-col cols="12" class="mt-10 mb-5">
            <v-input
              v-model="removeText"
              :placeholder="$t('message.pages.video.deleteModal.typeHere')"
              :label="$t('message.ai.dubbings.typeRemove')"
              autofocus
              hide-details
              @keyup.enter="handleConfirmDelete"
            >
            </v-input>
          </v-col>
          <v-col cols="12" class="mb-5">
            <v-checkbox
              v-model="checkboxConfirmation"
              class="pt-0 mt-0"
              hide-details
            >
              <template v-slot:label>
                <span style="font-size: 14px">{{
                  $t('message.pages.video.deleteModal.checkboxText')
                }}</span>
              </template>
            </v-checkbox>
          </v-col>
        </v-row>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions class="px-7 py-6">
        <v-spacer></v-spacer>
        <base-btn type="tertiary" class="mr-4" text @click="handleCloseModal">
          {{ $t('message.cancel') }}
        </base-btn>
        <v-tooltip bottom :disabled="removeVerification">
          <template v-slot:activator="{ on, attrs }">
            <div v-bind="attrs" v-on="on">
              <base-btn @click="handleRemove" :disabled="!removeVerification">
                <span>{{ $t('message.confirm') }}</span>
              </base-btn>
            </div>
          </template>
          <span>{{ $t('message.fieldAlertProceed') }}</span>
        </v-tooltip>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import i18n from '@/translations/lang.js'

export default {
  name: 'removeAiModal',
  props: {
    title: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      required: true,
    },
    modalKey: {
      type: String,
      required: true,
    },
    subtitle: {
      type: String,
    },
  },
  data: () => ({
    removeText: '',
    open: false,
    checkboxConfirmation: false,
  }),
  mounted() {
    this.$root.$on(
      `openAiDeleteModal${this.modalKey}`,
      () => (this.open = true)
    )
    this.$root.$on(`closeAiDeleteModal${this.modalKey}`, () =>
      this.handleCloseModal()
    )
  },
  beforeDestroy() {
    this.$root.$off(`openAiDeleteModal${this.modalKey}`)
    this.$root.$off(`closeAiDeleteModal${this.modalKey}`)
  },
  watch: {
    open(value) {
      if (!value) {
        this.handleCloseModal()
      }
    },
  },
  methods: {
    handleCloseModal() {
      this.open = false
      this.removeText = ''
      this.checkboxConfirmation = false
    },
    handleConfirmDelete() {
      if (this.removeVerification) {
        this.handleRemove()
      }
    },
    handleRemove() {
      this.$emit('confirm')
    },
  },
  computed: {
    removeVerification() {
      return (
        this.removeText.toUpperCase() ===
          i18n.t('message.remove').toUpperCase() && this.checkboxConfirmation
      )
    },
  },
}
</script>
<style lang="scss" scoped>
::v-deep .v-text-field__slot .v-label {
  margin-left: -10px;
}
</style>
